import { render } from "./DownloadFooter.vue?vue&type=template&id=7cdd4e3b&scoped=true"
const script = {}

import "./DownloadFooter.vue?vue&type=style&index=0&id=7cdd4e3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cdd4e3b"]])

export default __exports__